export default __webpack_public_path__ + "media/images/svg/fb-icon-2e0b4c83b29ffa6b5f1508d2c6d1eb8e.svg";